import { render, staticRenderFns } from "./FormPago.vue?vue&type=template&id=4e8fc1d3"
import script from "./FormPago.vue?vue&type=script&lang=js"
export * from "./FormPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports